import MUIStack, { StackProps as MuiStackProps } from '@mui/material/Stack';

export type StackProps<C extends React.ElementType = React.ElementType> = MuiStackProps<C, { component?: C }>;

export const Stack = MUIStack;
